import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const childPersonalityDiagnosis: BlogMetaData = {
  title: '子どもの性格診断｜幼児の気質を5つの行動傾向で見る考え方と結果の読み方',
  description:
    '子どもの性格診断を受ける前に知りたい、幼児の性格・気質・行動傾向の違いと固定タイプにしない見方を解説。挑戦・探究・こだわり・繊細さ・感覚探索の5つの観察軸と、診断結果の読み方をまとめます。',
  thumbnailUrl: '/img/blog-child-personality-diagnosis.webp',
  filePath: buildBlogFilePath('child-personality-diagnosis'),
  category: BLOG_CATEGORY.PARENTING,
};
